module.exports = __webpack_public_path__ + "img/antes_despues_64.6b329fde.png";